<template>
  <PageContainer>
    <View gap="lg" direction="column">
      <View direction="column" gap="xs">
        <Text variant="h1">Team</Text>
        <Text variant="body-medium" color="secondary" align="start">
          Who works this unit, and what each of them does
        </Text>
      </View>

      <PropertyTeam :subject="subject" />
    </View>
  </PageContainer>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { PageContainer, Text, View } from '@tallo/design-system';
import { AppRouteNames } from '@tallo/investor/navigation';
import { PropertyTeam, TeamSubject, usePropertyStore } from '@tallo/investor/property';

const route = useRoute();
const router = useRouter();
const propertyStore = usePropertyStore();
const subject = computed<TeamSubject>(() => ({ kind: 'property', id: route.params.propertyId as string }));

// A unit in a building has no team of its own: a link to one lands on its building's
watch(
  () => propertyStore.property?.buildingId,
  (buildingId) => {
    if (buildingId) {
      router.replace({ name: AppRouteNames.INVESTOR_BUILDING_TEAM, params: { buildingId } });
    }
  },
  { immediate: true },
);
</script>
